import { Typography } from "@mui/material"
import { ReactElement } from "react"

interface IFormPageProps {
  title: string
}

export function FormPageHeader(props: IFormPageProps): ReactElement {
  return (
    <Typography fontSize={25} color="#250048">
      {props.title}
    </Typography>
  )
}
